// Standard library imports
import React, { useContext, useEffect, useState } from 'react';

// External library imports
import { useLocation, useHistory } from 'react-router-dom';
import _, { get as LodashGet } from 'lodash';

// Internal module imports
import TabsComponent from '../../components/Tabs/Tabs';
import { AuthContext } from '../../context/AuthContext';
import { LoaderContext } from '../../context/LoaderContext';
import { START_LOADER, STOP_LOADER } from '../../constants';
import Tags from './Tags/Tags';
import Groups from './Groups/Groups';
import Details from './Details/Details';
import { sortByName } from '../../utils/objectHelper';
import AllChargers from './AllChargers/AllChargers';
import Sessions from './Sessions/Sessions';
import { SCService } from '../../services/SCService';
import { LicenseService } from '../../services/LicenseService';
import { momentTimeFormater } from '../../utils/dateHelper';
import moment from 'moment';

// Css module imports
import classes from './SmartCharging.module.css';
import SiteOperationsDashboard from './SiteOperationsDashboard/SiteOperationsDashboard';

const SmartCharging = () => {
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);

    const { state } = useContext(AuthContext);
    const customer = LodashGet(state, 'user.customerId');
    const licenseTypeId = state.isAuthorized ? queryParams.get('licenseTypeId') : '';

    const enabledLicense = LodashGet(state, `user.customerId.enabledLicense.${licenseTypeId}`);
    const settings = enabledLicense?.settings;
    const tabSettings = {
        details: settings?.details ? settings.details : false,
        SOD: settings?.SOD ? settings.SOD : false,
        tags: settings?.tags ? settings.tags : false,
        sites: settings?.sites ? settings.sites : false,
        sessions: settings?.sessions ? settings.sessions : false,
        chargers: settings?.chargers ? settings.chargers : false,
    };

    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });

    const [queryParamsData] = useState({
        subTab: queryParams.get('subTab') ? Number(queryParams.get('subTab')) : '',
        tab: queryParams.get('tab') ? Number(queryParams.get('tab')) : '',
        limit: queryParams.get('limit') ? Number(queryParams.get('limit')) : '',
        date: queryParams.get('date') ? new Date(queryParams.get('date')) : '',
        createTagModal: queryParams.get('createTagModal') && queryParams.get('createTagModal') === 'true' ? Boolean(queryParams.get('createTagModal')) : false,
        evseId: queryParams.get('evseId') ? queryParams.get('evseId') : null,
        connector: queryParams.get('connector') ? queryParams.get('connector') : null,
        dateRange: queryParams.get('dateRange') ? JSON.parse(queryParams.get('dateRange')) : '',
        evse: queryParams.get('evse') ? JSON.parse(queryParams.get('evse')) : '',
        group: queryParams.get('group') ? JSON.parse(queryParams.get('group')) : '',
        tag: queryParams.get('tag') ? JSON.parse(queryParams.get('tag')) : '',
        status: queryParams.get('status') ? JSON.parse(queryParams.get('status')) : '',
    });
    const [open, setOpen] = useState(false);
    const [selectedOuterIndex, setSelectedOuterIndex] = useState(queryParamsData.tab ? queryParamsData.tab : 0);

    const updateQueryParams = (type, value) => {
        let queryParamsNew = queryParams;
        if (type === 'tab') {
            const licenseTypeId = queryParamsNew.get('licenseTypeId');
            queryParamsNew = new URLSearchParams();
            queryParamsNew.set('licenseTypeId', licenseTypeId);
        }
        queryParamsNew.set(type, value);
        history.push({ search: queryParamsNew.toString() });
    };
    const [instances, setInstances] = useState([]);
    const [selectedInstance, setSelectedInstance] = useState({});
    const [sites, setSites] = useState([]);
    const [sitesHash, setSitesHash] = useState({});
    const [sitesDetailsHash, setSitesDetailHash] = useState({});

    useEffect(() => {
        getAllSites();
    }, []);

    useEffect(() => {
        if (licenseTypeId) {
            LicenseService.getLicenseTypeDetails(
                customer._id,
                licenseTypeId,
                { date: momentTimeFormater(moment()).format() },
                () => startLoader('getInstances'),
                handleGetInstanceSuccess,
                handleError,
                () => stopLoader('getInstances')
            );
        }
    }, [licenseTypeId]);

    useEffect(() => {
        updateQueryParams('evseId', selectedInstance?.meta?.evseId);
    }, [selectedInstance]);

    const getAllSites = () => {
        SCService.GetAllGroups(
            { skip: 0, limit: 10000 },
            () => startLoader('getSites'),
            handleGetSitesSuccess,
            handleError,
            () => stopLoader('getSites')
        );
    };

    const handleGetSitesSuccess = ({ data }) => {
        const { groups } = data?.data;
        const siteHash = {};
        const sitesDetailsHashTemp = {};
        const processedData = groups?.map((item) => {
            _.set(siteHash, item._id, item.name);
            _.set(sitesDetailsHashTemp, item._id, item);
            return {
                label: item.name,
                value: item._id,
                mode: item.mode
            };
        });
        setSites(processedData);
        setSitesHash(siteHash);
        setSitesDetailHash(sitesDetailsHashTemp);
    };

    const handleError = (err) => {
        console.log(err);
    };

    const handleGetInstanceSuccess = ({ data }) => {
        let allGroupsArray = data.data;
        allGroupsArray = sortByName(allGroupsArray);
        let processedGroups = allGroupsArray.map((device) => {
            device.hyperlink = (
                <div className="link" onClick={() => setSelectedInstance(device)}>
                    {device.name}
                </div>
            );

            return device;
        });
        const processedData = processedGroups.flat();

        setInstances(processedData);
        setSelectedInstance(queryParamsData.evseId ? processedData.find((charger) => charger.meta.evseId === queryParamsData.evseId) : processedData[0]);
    };

    let tabs = [
        ...(tabSettings.details
            ? [
                {
                    name: 'Details',
                    component: (
                        <Details
                            instances={instances}
                            sites={sitesHash}
                            selectedInstance={selectedInstance}
                            setSelectedInstance={setSelectedInstance}
                            licenseTypeId={licenseTypeId}
                            updateQueryParams={updateQueryParams}
                            queryParamsData={queryParamsData}
                        />
                    ),
                },
            ]
            : []),
        ...(tabSettings.SOD
            ? [
                {
                    name: 'SOD',
                    component: (
                        <SiteOperationsDashboard
                            sites={sites}
                            updateQueryParams={updateQueryParams}
                            queryParamsData={queryParamsData}
                        />
                    ),
                },
            ]
            : []),
        ...(tabSettings.tags
            ? [
                {
                    name: 'Tags',
                    component: <Tags sites={sites} updateQueryParams={updateQueryParams} queryParamsData={queryParamsData} />,
                },
            ]
            : []),
        ...(tabSettings.sites
            ? [
                {
                    name: 'Sites',
                    component: <Groups updateQueryParams={updateQueryParams} queryParamsData={queryParamsData} />,
                },
            ]
            : []),
        ...(tabSettings.sessions
            ? [
                {
                    name: 'Sessions',
                    component: <Sessions sites={sites} updateQueryParams={updateQueryParams} queryParamsData={queryParamsData} instances={instances} />,
                },
            ]
            : []),

        ...(tabSettings.chargers
            ? [
                {
                    name: 'Chargers',
                    component: <AllChargers sites={sites} updateQueryParams={updateQueryParams} queryParamsData={queryParamsData} devices={instances} />,
                },
            ]
            : []),
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <div className={classes.Ventilation + ' ventilation'}>
                <TabsComponent
                    selectedIndex={selectedOuterIndex}
                    tabs={tabs}
                    isOpen={open}
                    setOpen={setOpen}
                    onChangeTab={(index) => {
                        setSelectedOuterIndex(index);
                        updateQueryParams('tab', index);
                    }}
                />
            </div>
        </div>
    );
};

export default SmartCharging;
